export default __webpack_public_path__ + "e6c41fa763907db6279786f36535e1fa.png";